module.exports = __webpack_public_path__ + "static/media/Red-orchid-sessions-gig.8f757c80.jpg";